/* eslint-disable @typescript-eslint/no-explicit-any */
import { GeneralActionType } from 'store/actionTypes/general-action-type';
import { IAction, IGeneralState } from 'store/state/app-state';

export const GeneralReducer = (state: IGeneralState = null, action: IAction<boolean>): IGeneralState => {
    switch (action.type) {
        case GeneralActionType.SHOW_LOADER:
            return {
                showLoader: action.payload,
            };
        default:
            return state;
    }
};
